import { IGif } from '@giphy/js-types'
import styled from 'styled-components'

export enum RenditionType {
    Small = 'downsized',
    Social = 'downsized_large',
    Original = 'original',
    MP4 = 'original_mp4',
}

const TrayContainer = styled.div<{ showsMp4: boolean }>`
    display: flex;
    flex-direction: row;
    width: ${(props) => (props.showsMp4 ? '380' : '300')}px;
    justify-content: space-between;
    margin: auto;
    margin-top: 40px;
`

const RenditionSelector = styled.span<{ selected: boolean }>`
    font-size: 13px;
    cursor: pointer;
    opacity: 0.6;
    ${({ selected }) =>
        selected &&
        `
        opacity: 1.0;
        border-bottom: solid .8px white;
    `}
    span {
        font-weight: bold;
    }
`
type Props = {
    currentRendition: RenditionType
    setRenditionType: (whichRendition: RenditionType) => void
    showsMp4?: boolean
    gif: IGif
}

function convertToMb(sizeInBytes: number | string) {
    return (Number(sizeInBytes) / (1024 * 1024)).toFixed(2)
}

export const RenditionTray = ({ currentRendition, setRenditionType, gif, showsMp4 = false }: Props) => {
    const smallSize = gif.images[RenditionType.Small].size
    const socialSize = gif.images[RenditionType.Social].size
    const originalSize = gif.images[RenditionType.Original].size
    const mp4Size = gif.images[RenditionType.MP4].mp4_size

    return (
        <TrayContainer showsMp4={showsMp4}>
            {smallSize && (
                <RenditionSelector
                    onClick={() => setRenditionType(RenditionType.Small)}
                    selected={currentRendition === RenditionType.Small}
                >
                    <span>Small</span> {convertToMb(smallSize)}mb
                </RenditionSelector>
            )}
            {socialSize && (
                <RenditionSelector
                    onClick={() => setRenditionType(RenditionType.Social)}
                    selected={currentRendition === RenditionType.Social}
                >
                    <span>Social</span> {convertToMb(socialSize)}mb
                </RenditionSelector>
            )}
            {originalSize && (
                <RenditionSelector
                    onClick={() => setRenditionType(RenditionType.Original)}
                    selected={currentRendition === RenditionType.Original}
                >
                    <span>Original</span> {convertToMb(originalSize)}mb
                </RenditionSelector>
            )}
            {showsMp4 && mp4Size && (
                <RenditionSelector
                    onClick={() => setRenditionType(RenditionType.MP4)}
                    selected={currentRendition === RenditionType.MP4}
                >
                    <span>MP4</span> {convertToMb(mp4Size)}mb
                </RenditionSelector>
            )}
        </TrayContainer>
    )
}
